import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BuildEaseLogo } from "@/components/BuildEaseLogo";
import { CADGridBackground } from "@/components/CADGridBackground";
import { HUDStatusBadge } from "@/components/HUDStatusBadge";

const COPY = {
  terms: { title: "Terms of Service", status: "TERMS_PENDING" },
  privacy: { title: "Privacy Policy", status: "PRIVACY_PENDING" },
} as const;

// Placeholder legal pages — full content ships later.
export default function LegalScreen({ kind }: { kind: keyof typeof COPY }) {
  const { title, status } = COPY[kind];
  return (
    <div
      data-testid={`legal-${kind}-screen`}
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-obsidian px-6"
    >
      <CADGridBackground opacity={0.35} />
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="relative flex flex-col items-center gap-5 text-center"
      >
        <BuildEaseLogo height={44} />
        <h1 className="font-display text-2xl font-semibold tracking-tight text-white">{title}</h1>
        <HUDStatusBadge status={status} tone="accent" />
        <Link
          to="/signup"
          data-testid="legal-back-link"
          className="font-mono text-xs uppercase tracking-[0.18em] text-cad transition-colors hover:text-white"
        >
          ← Back to sign up
        </Link>
      </motion.div>
    </div>
  );
}
